module.exports = __webpack_public_path__ + "img/9788954637268.92c9e743.jpg";